import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";
import { getComponent } from "./projects/financialDetailsSlice";
import { setKPLBSection } from "./admin-micro-project/userSlice";
import { createMainProject } from "./rmk-information/mainProjectsSlice";
import { current } from "immer";
import {
  addNewProjectScope,
  deleteNewProjectScope,
  updateNewProjectScope,
  addProjectScopeByYear,
  updateProjectScopeByYear,
  updateCeilingAmount,
  saveRevisedScope,
} from "./certify/projectsSlice";

export const getMinistries = createAsyncThunk(
  "utils/getMinistries",
  async (props) => {
    try {
      const { source } = props;
      const response = await axios.get(`/utils/ministries/get`, {
        cancelToken: source.token,
      });

      const data = await response.data;

      return data;
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log(error.message);
      } else {
        console.error(error);
      }
    }
  },
);

export const getDepartments = createAsyncThunk(
  "utils/getDepartments",
  async (props) => {
    try {
      const { source } = props;
      const response = await axios.get(`/utils/departments/get`, {
        cancelToken: source.token,
      });

      const data = await response.data;

      return data;
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log(error.message);
      } else {
        console.error(error);
      }
    }
  },
);

export const getBranches = createAsyncThunk("utils/getBranches", async () => {
  const response = await axios.get(`/utils/branches/get`);

  const data = await response.data;

  return data;
});

export const getExecutingAgencies = createAsyncThunk(
  "utils/getExecutingAgencies",
  async (props) => {
    try {
      const { source } = props;
      const response = await axios.get(`/utils/executing-agencies/get`, {
        cancelToken: source.token,
      });

      const data = await response.data;

      return data;
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log(error.message);
      } else {
        console.error(error);
      }
    }
  },
);

export const getCategories = createAsyncThunk(
  "utils/getCategories",
  async () => {
    const response = await axios.get(`/utils/categories/get`);

    const data = await response.data;

    return data;
  },
);

export const getTargetGroups = createAsyncThunk(
  "utils/getTargetGroups",
  async (props) => {
    try {
      const { source } = props;
      const response = await axios.get(`/utils/target-groups/get`, {
        cancelToken: source.token,
      });

      const data = await response.data;

      return data;
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log(error.message);
      } else {
        console.error(error);
      }
    }
  },
);

export const getPrograms = createAsyncThunk(
  "utils/getPrograms",
  async (props) => {
    try {
      const { params, source } = props;
      const response = await axios.get(`/utils/programs/get`, {
        params,
        cancelToken: source.token,
      });

      const data = await response.data;

      return data;
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log(error.message);
      } else {
        console.error(error);
      }
    }
  },
);

export const getMainProjects = createAsyncThunk(
  "utils/getMainProjects",
  async (props) => {
    try {
      const { source, params } = props;
      const response = await axios.get(`/utils/main-projects/get?with=query`, {
        params,
        cancelToken: source.token,
      });

      const data = await response.data;

      return data;
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log(error.message);
      } else {
        console.error(error);
      }
    }
  },
);

export const getProgramMainProjects = createAsyncThunk(
  "utils/getProgramMainProjects",
  async (props) => {
    try {
      const { params } = props;
      const response = await axios.get(`/utils/main-projects/get`, {
        params,
      });

      const data = await response.data;

      return data;
    } catch (error) {
      console.error(error);
    }
  },
);

export const getUpenSections = createAsyncThunk(
  "utils/getUpenSections",
  async (props) => {
    try {
      const { source } = props;
      const response = await axios.get(`/utils/upen-sections/get`, {
        cancelToken: source.token,
      });

      const data = await response.data;

      return data;
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log(error.message);
      } else {
        console.error(error);
      }
    }
  },
);

export const getRmkItems = createAsyncThunk(
  "utils/getRmkItems",
  async (props) => {
    try {
      const { source } = props;
      const response = await axios.get(`/utils/rmk-items/get`, {
        cancelToken: source.token,
      });

      const data = await response.data;

      return data;
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log(error.message);
      } else {
        console.error(error);
      }
    }
  },
);

export const getDistrictItems = createAsyncThunk(
  "utils/getDistrictItems",
  async (source) => {
    try {
      const response = await axios.get(`/utils/district-items/get`, {
        cancelToken: source.token,
      });

      const data = await response.data;

      return data;
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log(error.message);
      } else {
        console.error(error);
      }
    }
  },
);

export const getParliamentItems = createAsyncThunk(
  "utils/getParliamentItems",
  async (source) => {
    try {
      const response = await axios.get(`/utils/parliament-items/get`, {
        cancelToken: source.token,
      });

      const data = await response.data;

      return data;
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log(error.message);
      } else {
        console.error(error);
      }
    }
  },
);

export const getStateLegislativeAssembly = createAsyncThunk(
  "utils/getStateLegislativeAssembly",
  async (source) => {
    try {
      const response = await axios.get(
        `/utils/state-legislative-assembly-items/get`,
        {
          cancelToken: source.token,
        },
      );

      const data = await response.data;

      return data;
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log(error.message);
      } else {
        console.error(error);
      }
    }
  },
);

export const getUsers = createAsyncThunk("utils/getUsers", async (props) => {
  try {
    const { params, source } = props;
    const response = await axios.get(`/utils/user-items/get`, {
      params,
      cancelToken: source.token,
    });

    const data = await response.data;

    return data;
  } catch (error) {
    if (axios.isCancel(error)) {
      console.log(error.message);
    } else {
      console.error(error);
    }
  }
});

export const getUpenOfficers = createAsyncThunk(
  "utils/getUpenOfficers",
  async (props) => {
    try {
      const { source } = props;
      const response = await axios.get(`/utils/upen-officers/get`, {
        cancelToken: source.token,
      });

      const data = await response.data;

      return data;
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log(error.message);
      } else {
        console.error(error);
      }
    }
  },
);

export const getKPLBOfficers = createAsyncThunk(
  "utils/getKPLBOfficers",
  async (props) => {
    try {
      const { source } = props;
      const response = await axios.get(`/utils/kplb-officers/get`, {
        cancelToken: source.token,
      });

      const data = await response.data;

      return data;
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log(error.message);
      } else {
        console.error(error);
      }
    }
  },
);

export const getSustainableDevelopmentGoals = createAsyncThunk(
  "utils/getSustainableDevelopmentGoals",
  async (props) => {
    try {
      const { source } = props;
      const response = await axios.get(
        `/utils/sustainable-development-goal-items/get`,
        {
          cancelToken: source.token,
        },
      );

      const data = await response.data;

      return data;
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log(error.message);
      } else {
        console.error(error);
      }
    }
  },
);

export const getProjectScope = createAsyncThunk(
  "utils/getProjectScope",
  async (props) => {
    try {
      const { source } = props;
      const response = await axios.get(`utils/project-scope/get`, {
        cancelToken: source.token,
      });

      const data = await response.data;

      return data;
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log(error.message);
      } else {
        console.error(error);
      }
    }
  },
);

export const getCreditScoreCriteriaList = createAsyncThunk(
  "utils/getCreditScoreCriteriaList",
  async (props) => {
    try {
      const { source } = props;
      const response = await axios.get(`utils/credit-score-criteria/get`, {
        cancelToken: source.token,
      });

      const data = await response.data;

      return data;
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log(error.message);
      } else {
        console.error(error);
      }
    }
  },
);

export const getOptions = createAsyncThunk(
  "utils/getOptions",
  async (props) => {
    try {
      const { source, params } = props;

      const rmkData = await axios.get(`/utils/rmk-items/get`, {
        cancelToken: source.token,
      });

      const ministryData = await axios.get(`utils/ministries/get`, {
        params,
        cancelToken: source.token,
      });

      const departmentData = await axios.get(`/utils/departments/get`, {
        params,
        cancelToken: source.token,
      });

      const branchData = await axios.get(`/utils/branches/get`, {
        params,
        cancelToken: source.token,
      });

      const programData = await axios.get(`utils/programs/get`, {
        params,
        cancelToken: source.token,
      });

      // const program_ids = programData.data.map((program) => program.id);

      // const mainProjectData = await axios.get(`utils/main-projects/get`, {
      //   params: {
      //     program_ids: program_ids,
      //     rmk_id: params.rmk_id,
      //   },
      //   cancelToken: source.token,
      // });

      const upenSectionData = await axios.get(`/utils/upen-sections/get`, {
        cancelToken: source.token,
      });

      const data = {
        rmkItems: rmkData?.data,
        ministryItems: ministryData?.data,
        departmentItems: departmentData.data,
        branchItems: branchData.data,
        programItems: programData.data,
        // mainProjectItems: mainProjectData.data,
        upenSectionItems: upenSectionData.data,
      };

      return data;
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log(error.message);
      } else {
        console.error(error);
      }
    }
  },
);

export const getProgressStatusOptions = createAsyncThunk(
  "utils/getProgressStatusOptions",
  async (props) => {
    try {
      const { source } = props;

      const response = await axios.get(`utils/progress-status-options/get`, {
        cancelToken: source.token,
      });

      const data = await response.data;

      return data;
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log(error.message);
      } else {
        console.error(error);
      }
    }
  },
);

export const getMainSectorOptions = createAsyncThunk(
  "utils/getMainSectorOptions",
  async (props) => {
    try {
      const { source, params } = props;

      const response = await axios.get(`utils/main-sector-options/get`, {
        params,
        cancelToken: source.token,
      });

      const data = await response.data;

      return data;
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log(error.message);
      } else {
        console.error(error);
      }
    }
  },
);

export const checkPriorityNumber = createAsyncThunk(
  "utils/checkPriorityNumber",
  async (props) => {
    try {
      const { params } = props;

      const response = await axios.get(`utils/check-project-priority`, {
        params,
      });

      const data = await response.data;

      return data;
    } catch (error) {
      console.error(error);
    }
  },
);

const initialState = {
  rmkValue: null,
  inputLoading: false,
  dndLoading: false,
  certifyProjectProfile: null,
  ceilingItems: [],
  certifyFinancial: [],
  rejectedComponents: [],
  ceilingFlowYearly: [],
  error: {},
  checkBoxItems: {
    sustainableDevelopmentGoals: [],
  },
  tabValue: {
    dashboardTab: "0",
    reportProfileTab: "0",
  },
  dropdownItems: {
    ministries: [],
    departments: [],
    branches: [],
    executingAgencies: [],
    categories: [],
    groups: [],
    programs: [],
    mainProjects: [],
    upen_sections: [],
    kplb_officers: [],
    rmkItems: [],
    districtItems: [],
    parliamentItems: [],
    stateLegislativeAssemblyItems: [],
    userItems: [],
    upenOfficers: [],
    projectScopeItems: [],
    creditScoreCriteriaList: [],
    progressStatusOptions: [],
    mainSectorOptions: [],
  },
  dropDownItemLoading: false,
  virementSource: {
    isLoading: false,
    data: null,
  },
  bendahari: [],
};

export const utilsSlice = createSlice({
  name: "utils",
  initialState,
  reducers: {
    // addScopeProject: (state, action) => {
    //   state.certifyFinancial.push(action.payload);
    // },
    removeScopeProject: (state, action) => {
      const rowIndex = action.payload;
      state.certifyFinancial = state.certifyFinancial.filter(
        (obj, index) => index !== rowIndex,
      );
    },
    createCertifyProfileProject: (state, action) => {
      const data = action.payload;
      state.certifyProjectProfile = data;
    },
    updateCertifyProfileProject: (state, action) => {
      const { name, value } = action.payload;

      if (name === "main_sector") {
        const currentMainSector = current(
          state.certifyProjectProfile.main_sector,
        );

        const isSameSector = currentMainSector?.id === value?.id;

        state.certifyProjectProfile = {
          ...state.certifyProjectProfile,
          [name]: value,
          ...(isSameSector ? {} : { strategic_directions: [] }),
        };
      } else {
        state.certifyProjectProfile = {
          ...state.certifyProjectProfile,
          [name]: value,
        };
      }
    },
    createCeilingItems: (state, action) => {
      const data = action.payload;
      state.ceilingItems = data;
    },
    createCertifyFinancial: (state, action) => {
      const data = action.payload;
      state.certifyFinancial = data;
    },
    updateCertifyFinancialItem: (state, action) => {
      const { field, data } = action.payload;

      if (field === "main-budget") {
        const { id, cost_required } = data;

        state.certifyFinancial = state.certifyFinancial.map((obj) => {
          if (obj.id === id) {
            return {
              ...obj,
              cost_required: cost_required,
              revised_cost_required: cost_required,
            };
          }

          return obj;
        });
      }

      if (field === "ceiling-flow") {
        const { id, amount } = data;

        state.certifyFinancial = state.certifyFinancial.map((obj1) => {
          const updatedItem = obj1.ceiling_flow_details.map((obj2) => {
            if (obj2.id === id) {
              return {
                ...obj2,
                amount: amount,
              };
            }
            return obj2;
          });

          return {
            ...obj1,
            ceiling_flow_details: updatedItem,
          };
        });
      }
    },
    updateRevisedProjectScope: (state, action) => {
      const { id, value, type } = action.payload;

      if (type === "cost") {
        state.certifyFinancial = state.certifyFinancial.map((obj) => {
          if (obj.id === id) {
            return {
              ...obj,
              cost_required: value,
              revised_cost_required: value,
            };
          }
          return obj;
        });
      }
      if (type === "ceiling") {
        state.certifyFinancial = state.certifyFinancial.map((obj) => {
          if (obj.id === id) {
            const oldCeiling = parseFloat(obj.ceiling) || 0;
            const newCeiling = parseFloat(value) || 0;
            const diff = newCeiling - oldCeiling;

            const currentCost = parseFloat(obj.cost_required) || 0;
            const updatedCost = currentCost + diff || 0;
            return {
              ...obj,
              ceiling: value,
              revised_ceiling: value,
              cost_required: updatedCost.toFixed(2).toString(),
              revised_cost_required: updatedCost.toFixed(2).toString(),
            };
          }
          return obj;
        });
      }
      if (type === "scope") {
        state.certifyFinancial = state.certifyFinancial.map((obj) => {
          if (obj.id === id) {
            return {
              ...obj,
              cost_description: value.value,
            };
          }
          return obj;
        });
      }
      if (type === "ceiling-flow") {
        const { financial_detail_id, year, cost_description } = id;

        state.certifyFinancial = state.certifyFinancial.map((obj) => {
          if (obj.id !== financial_detail_id) return obj;

          return {
            ...obj,
            ceiling_flow_details: obj.ceiling_flow_details.map((subObj) => {
              if (
                subObj.year === year &&
                subObj.financial_detail_id === financial_detail_id
              ) {
                return {
                  ...subObj,
                  amount: value,
                };
              }
              return subObj;
            }),
          };
        });
      }
    },
    createRejectedScopeList: (state, action) => {
      const data = action.payload;
      state.rejectedComponents = data;
    },
    addComponent: (state, action) => {
      const { id, cost_description, ceiling_flow_details } = action.payload;

      state.rejectedComponents = state.rejectedComponents.filter(
        (item) => item.id !== id,
      );

      ceiling_flow_details.forEach((item) => {
        const newValues = {
          ...item,
          cost_description: cost_description,
        };
        state.certifyFinancial.push(newValues);
      });
    },

    removeComponent: (state, action) => {
      const id = action.payload;

      state.certifyFinancial = state.certifyFinancial.map((obj1) => {
        if (obj1.id === id) {
          const updated = obj1.ceiling_flow_details.map((obj2) => {
            return {
              ...obj2,
              amount: "0",
            };
          });
          return {
            ...obj1,
            cost_required: "0",
            revised_cost_required: "0",
            ceiling: "0",
            revised_ceiling: "0",
            ceiling_flow_details: updated,
          };
        }
        return obj1;
      });
    },

    resetComponentsState: (state, action) => {
      state.certifyFinancial = [];
      state.rejectedComponents = [];
    },

    resetDropdownItems: () => initialState.dropdownItems,

    setDashboardTab: (state, action) => {
      state.tabValue.dashboardTab = action.payload.toString();
    },

    setReportTab: (state, action) => {
      state.tabValue.reportProfileTab = action.payload.toString();
    },

    setBendahari: (state, action) => {
      state.bendahari = action.payload;
    },

    setUpdateBendahari: (state, action) => {
      const { code, api_status, isDisabled } = action.payload;
      state.bendahari = state.bendahari.map((item) => {
        if (item.code === code) {
          return {
            ...item,
            isDisabled: isDisabled,
            api_status: api_status,
          };
        }

        return item;
      });
    },

    moveCertifyFinancialItem: (state, action) => {
      const { oldValues, newValues, targetRow } = action.payload;

      // Validate input
      if (!oldValues || !newValues || !targetRow) {
        console.error("Invalid payload: missing required fields");
        return;
      }

      // Find the parent financial detail item
      const parentItemIndex = state.certifyFinancial.findIndex(
        (item) =>
          item.id === newValues.financial_detail_id ||
          (oldValues.financial_detail_id &&
            item.id === oldValues.financial_detail_id),
      );

      if (parentItemIndex === -1) {
        console.error("Parent financial detail not found");
        return;
      }

      const parentItem = state.certifyFinancial[parentItemIndex];

      // Create a deep copy of the parent item to modify
      const updatedParentItem = JSON.parse(JSON.stringify(parentItem));

      // Case 1: Moving from unassigned (no ceiling_flow_details exists)
      if (!oldValues.id && !parentItem.ceiling_flow_details) {
        const newFlowDetail = {
          ...newValues,
          id: Date.now(), // Temporary ID, should be replaced with real ID from backend
          year: targetRow,
          ceiling_flow_detail_stages: [],
          ceiling_flow_detail_notes: [],
          cost_description: parentItem.cost_description,
        };

        updatedParentItem.ceiling_flow_details = [newFlowDetail];
      }
      // Case 2: Moving existing flow detail to new year
      else if (oldValues.id) {
        // Remove from old year
        updatedParentItem.ceiling_flow_details =
          parentItem.ceiling_flow_details?.filter(
            (detail) => detail.id !== oldValues.id,
          ) || [];

        // Check if item already exists in target year
        const existingDetailIndex =
          updatedParentItem.ceiling_flow_details.findIndex(
            (detail) =>
              detail.year === targetRow &&
              detail.financial_detail_id === newValues.financial_detail_id,
          );

        if (existingDetailIndex !== -1) {
          // Merge with existing item in target year
          const existingDetail =
            updatedParentItem.ceiling_flow_details[existingDetailIndex];
          updatedParentItem.ceiling_flow_details[existingDetailIndex] = {
            ...existingDetail,
            amount: (
              parseFloat(existingDetail.amount) + parseFloat(newValues.amount)
            ).toString(),
            ceiling_flow_detail_stages:
              existingDetail.ceiling_flow_detail_stages.map((stage) => ({
                ...stage,
                amount: (
                  parseFloat(stage.amount) + parseFloat(newValues.amount)
                ).toString(),
              })),
          };
        } else {
          // Add as new item in target year
          updatedParentItem.ceiling_flow_details.push({
            ...newValues,
            year: targetRow,
          });
        }
      }

      // Update the state with the modified parent item
      state.certifyFinancial = [
        ...state.certifyFinancial.slice(0, parentItemIndex),
        updatedParentItem,
        ...state.certifyFinancial.slice(parentItemIndex + 1),
      ];
    },

    setRmkValue: (state, action) => {
      state.rmkValue = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getMinistries.fulfilled, (state, action) => {
      state.dropdownItems.ministries = action.payload;
    });

    builder.addCase(getDepartments.fulfilled, (state, action) => {
      state.dropdownItems.departments = action.payload;
    });

    builder.addCase(getExecutingAgencies.fulfilled, (state, action) => {
      state.dropdownItems.executingAgencies = action.payload;
    });
    builder.addCase(getBranches.fulfilled, (state, action) => {
      state.dropdownItems.branches = action.payload;
    });
    builder.addCase(getCategories.fulfilled, (state, action) => {
      state.dropdownItems.categories = action.payload;
    });
    builder.addCase(getTargetGroups.fulfilled, (state, action) => {
      state.dropdownItems.groups = action.payload;
    });
    builder.addCase(getPrograms.fulfilled, (state, action) => {
      state.dropdownItems.programs = action.payload;
    });

    builder.addCase(getMainProjects.fulfilled, (state, action) => {
      if (Array.isArray(action.payload)) {
        state.dropdownItems.mainProjects = action.payload;
      }
    });

    builder.addCase(getUpenSections.fulfilled, (state, action) => {
      state.dropdownItems.upen_sections = action.payload;
    });

    builder.addCase(getKPLBOfficers.fulfilled, (state, action) => {
      state.dropdownItems.kplb_officers = action.payload;
    });

    builder.addCase(getRmkItems.fulfilled, (state, action) => {
      state.dropdownItems.rmkItems = action.payload;
    });

    builder.addCase(getDistrictItems.fulfilled, (state, action) => {
      state.dropdownItems.districtItems = action.payload;
    });

    builder.addCase(getParliamentItems.fulfilled, (state, action) => {
      state.dropdownItems.parliamentItems = action.payload;
    });

    builder.addCase(getStateLegislativeAssembly.fulfilled, (state, action) => {
      state.dropdownItems.stateLegislativeAssemblyItems = action.payload;
    });

    builder.addCase(getUsers.fulfilled, (state, action) => {
      state.dropdownItems.userItems = action.payload;
    });

    builder.addCase(getUpenOfficers.fulfilled, (state, action) => {
      state.dropdownItems.upenOfficers = action.payload;
    });

    builder.addCase(getProjectScope.fulfilled, (state, action) => {
      state.dropdownItems.projectScopeItems = action.payload;
    });

    builder.addCase(
      getSustainableDevelopmentGoals.fulfilled,
      (state, action) => {
        state.checkBoxItems.sustainableDevelopmentGoals = action.payload;
      },
    );

    builder.addCase(getCreditScoreCriteriaList.fulfilled, (state, action) => {
      state.dropdownItems.creditScoreCriteriaList = action.payload;
    });

    builder.addCase(getOptions.fulfilled, (state, action) => {
      const {
        rmkItems,
        ministryItems,
        departmentItems,
        branchItems,
        programItems,
        // mainProjectItems,
        upenSectionItems,
      } = action.payload;

      state.dropdownItems.rmkItems = rmkItems;
      state.dropdownItems.ministries = ministryItems;
      state.dropdownItems.departments = departmentItems;
      state.dropdownItems.branches = branchItems;
      state.dropdownItems.programs = programItems;
      // state.dropdownItems.mainProjects = mainProjectItems;
      state.dropdownItems.upen_sections = upenSectionItems;
    });

    builder.addCase(getComponent.fulfilled, (state, action) => {
      state.rejectedComponents.push(action.payload);
    });

    builder.addCase(getProgressStatusOptions.fulfilled, (state, action) => {
      state.dropdownItems.progressStatusOptions = action.payload;
    });

    builder.addCase(getMainSectorOptions.fulfilled, (state, action) => {
      state.dropdownItems.mainSectorOptions = action.payload;
    });

    builder.addCase(setKPLBSection.fulfilled, (state, action) => {
      const { id } = action.payload;
      state.dropdownItems.mainProjects = state.dropdownItems.mainProjects.map(
        (item) => {
          if (item.id === id) {
            return action.payload;
          }
          return item;
        },
      );
    });

    builder.addCase(createMainProject.fulfilled, (state, action) => {
      state.dropdownItems.mainProjects.push(action.payload);
    });

    builder.addCase(addNewProjectScope.pending, (state, action) => {
      state.inputLoading = true;
    });
    builder.addCase(addNewProjectScope.fulfilled, (state, action) => {
      const { data } = action.payload;

      state.certifyFinancial = data;
      state.inputLoading = false;
    });

    builder.addCase(updateNewProjectScope.pending, (state, action) => {
      state.inputLoading = true;
    });

    builder.addCase(updateNewProjectScope.fulfilled, (state, action) => {
      const { data } = action.payload;

      state.certifyFinancial = state.certifyFinancial.map((obj) => {
        if (obj.id === data.id) {
          return data;
        }
        return obj;
      });
      state.inputLoading = false;
    });

    builder.addCase(deleteNewProjectScope.fulfilled, (state, action) => {
      const { data } = action.payload;

      state.certifyFinancial = data;
    });

    builder.addCase(addProjectScopeByYear.pending, (state, action) => {
      state.dndLoading = true;
    });
    builder.addCase(addProjectScopeByYear.fulfilled, (state, action) => {
      const { data } = action.payload;

      state.certifyFinancial = data;
      state.dndLoading = false;
    });
    builder.addCase(updateProjectScopeByYear.pending, (state, action) => {
      state.dndLoading = true;
    });
    builder.addCase(updateProjectScopeByYear.fulfilled, (state, action) => {
      const { data } = action.payload;

      state.certifyFinancial = data;
      state.dndLoading = false;
    });
    builder.addCase(updateCeilingAmount.pending, (state, action) => {
      state.inputLoading = true;
    });
    builder.addCase(updateCeilingAmount.fulfilled, (state, action) => {
      const { data } = action.payload;

      state.certifyFinancial = data;
      state.inputLoading = false;
    });
    builder.addCase(saveRevisedScope.pending, (state, action) => {
      state.inputLoading = true;
    });
    builder.addCase(saveRevisedScope.fulfilled, (state, action) => {
      state.inputLoading = false;
    });
  },
});

export const {
  createCertifyProfileProject,
  updateCertifyProfileProject,
  createCeilingItems,
  createCertifyFinancial,
  addComponent,
  removeComponent,
  updateCertifyFinancialItem,
  updateRevisedProjectScope,
  createRejectedScopeList,
  removeScopeProject,
  resetComponentsState,
  resetDropdownItems,
  setDashboardTab,
  setReportTab,
  setBendahari,
  setUpdateBendahari,

  moveCertifyFinancialItem,

  setRmkValue,
} = utilsSlice.actions;

export default utilsSlice.reducer;
